import { get } from 'utils/api';
import { VEHICLES, USERS_WITH_DISABLED_AUTOCHARGE } from './endpointURLs';

export const getCustomersWithAutochargeDisabled = (data) => {
  const page = data?.page || 1;
  const searchQuery = data?.search ? `&search=${data.search}` : '';  
  return get(`${VEHICLES}/${USERS_WITH_DISABLED_AUTOCHARGE}?page=${page}${searchQuery}`);  
};

 export const updateAutocharge = {
  getCustomersWithAutochargeDisabled
 };